export default "__VITE_PUBLIC_ASSET__f070a3a1__"